// Hideo - the page shown now (from the router) and navigation helpers for components
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { NAV_OF, isPage, type PageId } from '../navigation'
import { app } from '../features/app'

export function usePage() {
  const route = useRoute()
  const page = computed<PageId | null>(() => (isPage(route.name) ? route.name : null))
  const section = computed(() => (page.value ? NAV_OF[page.value] : null))
  /** Goes to a page (the legacy switchTab shows it at once and updates the address) */
  const goTo = (p: PageId) => app.switchTab(p)
  return { page, section, goTo }
}
